export default {
  apiKey: "AIzaSyAXwLeA-wid9gWoQqEmoNrQgQ0bw8ZsIlU",
  authDomain: "mylinko-4fe49.firebaseapp.com",
  databaseURL: "https://mylinko-4fe49.firebaseio.com",
  projectId: "mylinko-4fe49",
  storageBucket: "mylinko-4fe49.appspot.com",
  messagingSenderId: "849646771433",
  appId: "1:849646771433:web:3529d4a8913c44e81ea478",
  measurementId: "G-HQHFHQ6264"
}




// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js